"use strict";
import { theme } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import colors from './colors.mjs';

const getAlertBg = (props) => {
  return mode(`${props.colorScheme}.50`, `${{ ...theme.colors, ...colors }[props.colorScheme][700]}44`)(props);
};
const components = {
  Textarea: {
    baseStyle: (props) => ({
      focusBorderColor: mode(`${props.colorScheme}.500`, `${props.colorScheme}.300`)(props)
    }),
    variants: {
      outline: (props) => ({
        field: {
          _placeholder: { color: mode("gray.500", "gray.400")(props) }
        }
      })
    }
  },
  Input: {
    baseStyle: (props) => ({
      focusBorderColor: mode(`${props.colorScheme}.500`, `${props.colorScheme}.300`)(props)
    }),
    variants: {
      outline: (props) => ({
        field: {
          _placeholder: { color: mode("gray.500", "gray.400")(props) }
        }
      })
    }
  },
  Spinner: {
    baseStyle: (props) => ({
      color: mode(`${props.colorScheme}.500`, `${props.colorScheme}.300`)(props)
    })
  },
  Button: {
    variants: {
      solid: (props) => {
        const { colorScheme } = props;
        if (colorScheme === "blue" || colorScheme === "green") {
          return {
            bg: `${colorScheme}.500`,
            color: "white"
          };
        }
        return theme.components.Button.variants?.solid(props);
      },
      subtle: (props) => ({
        color: mode(`${props.colorScheme}.500`, `${props.colorScheme}.200`)(props),
        bg: mode("gray.100", "whiteAlpha.200")(props),
        _hover: {
          bg: mode("gray.200", "whiteAlpha.300")(props)
        },
        _active: {
          bg: mode("gray.300", "whiteAlpha.400")(props)
        }
      })
    }
  },
  Alert: {
    parts: ["container"],
    variants: {
      "left-accent": (props) => ({
        container: {
          bg: getAlertBg(props)
        }
      }),
      subtle: (props) => ({
        container: {
          bg: getAlertBg(props)
        }
      })
    }
  },
  Drawer: {
    parts: ["dialog"],
    baseStyle: (props) => ({
      dialog: {
        bg: mode("white", "gray.800")(props)
      }
    })
  },
  Link: {
    baseStyle: (props) => ({
      color: mode(`${props.colorScheme}.500`, `${props.colorScheme}.200`)(props),
      fontWeight: "semibold"
    })
  }
};

export { components as default };
